export const GA_ID = 'G-EPRW4CZC6R'

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void
  }
}

export function trackEvent(name: string, params?: Record<string, unknown>) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params)
  }
}

export function reportWebVitals() {
  import('web-vitals').then(({ onCLS, onINP, onLCP }) => {
    const sendToGA = ({ name, delta, id }: { name: string; delta: number; id: string }) => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, {
          event_category: 'Web Vitals',
          value: Math.round(name === 'CLS' ? delta * 1000 : delta),
          event_label: id,
          non_interaction: true,
        })
      }
    }

    onCLS(sendToGA)
    onINP(sendToGA)
    onLCP(sendToGA)
  })
}
